module.exports = __webpack_public_path__ + "img/checked-icon.c426096c.svg";